
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weingueter",
      function () {
        return require("private-next-pages/weingueter.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weingueter"])
      });
    }
  